<template>
  <div>
    <div class="logintitle">
      <img class="logoimg" src="/static/img/logo.png">
    </div>
    <div class="inputcont">
      <img class="fl headtext" src="/static/img/pwd.png">
      <input placeholder="请输入密码" id="pwd" class="text" :type="inputType" v-model="pwd1">
    </div>
    <div class="inputcont">
        <img class="fl headtext" src="/static/img/pwd.png">
        <input placeholder="请确认密码" id="pwd2" class="text" :type="inputType" v-model="pwd2">
    </div>
    <div class="loginbtdiv"><mt-button class="login-btn" size="large" type="primary" @click="sure()">完成</mt-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data () {
    return {
      inputType:'password',
      pwd1:'',
      pwd2:''
    }
  },
  methods: {
    sure: function(){
      var error = /^(\w){6,20}$/;
      if(!error.test(this.pwd1)){
          this.$toast('请输入6-20位字母数字下划线');
          return;
      }
      if(this.pwd1 != this.pwd2){
          this.$toast('两次输入密码不一致');
          return;
      }
      this.$http.post(
            domain("_setpassUrl"),
            {
              'mobile':this.$route.query.mobile,
              'mobileCode':this.$route.query.mobileCode,
              'password':$.md5(this.pwd1)
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.code == '0'){
                this.$router.push('/findpass/suc');
            }else if(response.body.code == '1'){
                this.$toast('验证码错误');
            }else if(response.body.code == '2'){
                this.$toast('验证码错误');
            }else if(response.body.code == '3'){
                this.$toast('修改失败');
            }else{
                this.$toast('系统错误');
            }
            },function(error){
        })
    }
  },
  components:{
  
  }
}
</script>
<style>
.logintitle{
  text-align: center;
  padding: 40px 0;
  font-size: 32px;
  color: #7d7d7d;
}
.login-btn{
    margin-top:15px;
}
.headtext{
    position: absolute;
    top: 15px;
    left:30px;
}
.inputcont input{
    padding-left:50px; 
}
.inputcont{
    position: relative;
    padding: 0 10px;
    margin-bottom:25px;
}
.spwd{
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
}
.inputcont img{
  width: 15px;
}
.loginbtdiv{
  padding: 0 10px;
}
.bottomlogin{
  margin-top: 10px;
  padding: 0 12px;
}
.bottomlogin a{
  color: #7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/module/findpass/SetPass.vue